// src/utils/date.js
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// Default tenant timezone (IST)
export const TZ = "Asia/Kolkata";

// Format only date in local tz
export const fmtDate = (d, f = "DD/MM/YYYY") =>
  d ? dayjs.utc(d).tz(TZ).format(f) : "";

// Format date+time in local tz
export const fmtDateTime = (d, f = "DD/MM/YYYY HH:mm") =>
  d ? dayjs.utc(d).tz(TZ).format(f) : "";

// Today in local tz (YYYY-MM-DD) for <input type="date"/>
export const todayYMD = () => dayjs().tz(TZ).format("YYYY-MM-DD");
